import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const POST_CONCEPT_REQUEST = "POST_CONCEPT_REQUEST";
export const POST_CONCEPT_SUCCESS = "POST_CONCEPT_SUCCESS";
export const POST_CONCEPT_ERROR = "POST_CONCEPT_ERROR";

//* ACTIONS ------------------------------------------------
export const postConceptRequest = (payload = {}, callback) => ({
  type: POST_CONCEPT_REQUEST,
  payload,
  callback,
});

export const postConceptSuccess = () => ({
  type: POST_CONCEPT_SUCCESS,
});

export const postConceptError = (error) => ({
  type: POST_CONCEPT_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const postConceptServiceRequest = async (data) => {
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data,
  });

  return request("/concepts", options);
};
